export default "__VITE_ASSET__DAkI5xnV__"